import MoreVertIcon from '@material-ui/icons/MoreVert'
import {Select, MenuItem} from '@material-ui/core'
import styled from 'styled-components'

const StyledSelect = styled(Select)`
  .MuiSelect-select {
  padding: 8px 32px 8px 8px;
  background: #ffffff !important;
    &:focus {
      background: #ffffff !important;
    }
  }
`

export const TableActionColumn = ({actionClick, menuList, row}) => {
  const action = (event, row) => {
    actionClick(event.target.value, row)
  }

  return (
    <StyledSelect
      value={''}
      onChange={(event) => action(event, row)}
      renderValue={null}
      disableUnderline
      variant="standard"
      IconComponent={MoreVertIcon}
    >
      {menuList.map((option) => (
        <MenuItem key={option.key} value={option.key}>
          {`${option.value}`}
        </MenuItem>
      ))}
    </StyledSelect>
  )
}
